import { constructURL } from 'helpers/url';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  setFaxType(event) {
    const url = constructURL(window.location.href, { fax_type: event.detail.target.getAttribute('value') });
    Turbo.visit(url.toString());
  }

  setPatient(event) {
    const url = constructURL(window.location.href, { patient_id: event.detail.target.getAttribute('value') });
    Turbo.visit(url.toString());
  }

  setNewFaxable(event) {
    const url = constructURL(window.location.href, { create_faxable: event.target.checked });
    Turbo.visit(url.toString());
  }

  setNewExternalPhysicianOrder(event) {
    const url = constructURL(window.location.href, { create_external_physician_order: event.target.checked });
    Turbo.visit(url.toString());
  }
}
